import { render, staticRenderFns } from "./code3.vue?vue&type=template&id=3fe01613&scoped=true&"
import script from "./code3.vue?vue&type=script&lang=js&"
export * from "./code3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe01613",
  null
  
)

export default component.exports